"use strict";

define('rs/form/formobjects/empty/empty.formobject.view',['rs/form/formobjects/base.formobject.view'], function (BaseFormObjectView) {
  var EmptyFormObjectView = BaseFormObjectView.extend({
    editable: false,
    isEmpty: true,
    templates: {},
    renderFormObject: function renderFormObject() {
      var el = this.getContentElement(),
        delegate = this.getDelegate();
      this.$el.addClass('empty').prev('.form-object-spacer').remove();
      el.html(this.renderDropControlsFragment({
        large: true,
        text: 'Drag an item here'
      }));
    }
  });
  return EmptyFormObjectView;
});

